<template>
    <div class="ugchooser">
        <span class="ugchooser_text" v-html="utext"></span>
        <div class="btn-group pull-right">
            <button class="btn btn-primary btnEditUsergroup" title="Изменить пользователей" @click="editUsergroup"><span class="glyphicon glyphicon-user"></span></button>
            <button v-if="copypaste" class="btn btn-warning btnCopyUsergroup" title="Копировать пользователей"><span class="glyphicon glyphicon-copy"></span></button>
            <button v-if="copypaste" class="btn btn-info btnPasteUsergroup" title="Вставить пользователей"><span class="glyphicon glyphicon-paste"></span></button>
            <input class="ugchooser_value" type="hidden" v-model="v1" :class="required?'inputrequired':''"/>
        </div>
        <uidialog v-model="dialogOpen" headerclass="info" :acceptbutton="submitUsergroup" closebutton='true' headericon="user" title="Редактирование пользователей" size="lg" :waitbuttons="updating">
            <span ref="inhtml"></span>
        </uidialog>
    </div>
</template>
<script>
    import axios from 'axios'
    import qs from 'qs'

    export default {
        props: ['copypaste','value','query','required'],
        data:function(){
            return {
                utext:null,
                uid:null,
                copydata:null,
                v1:null,
                editorhtml:null,
                dialogOpen:false,
                updating:false
            }
        },
        methods:{
            editUsergroup(){
                this.setInnerHTML(this.$refs.inhtml,"<img src='/icons/loading.gif'/>");
                this.dialogOpen=true;
                this.updating=false;
                axios.post("headless.php?action=core_editUsergroup",qs.stringify({
                        action:"core_editUsergroup",
                        id:this.v1
                    })).then(d=>{
                        this.setInnerHTML(this.$refs.inhtml,d.data);
                    });
                    
//                var dlgeditgroup=actInDialog({
//                    action:"core_editUsergroup",
//                    title:"Редактирование пользователей",
//                    class:"primary",
//                    data:{
//                        id:this.v1
//                    },
//                    closebutton:true,
//                    close:(this.onclose!=null)?this.onclose:null,
//                    acceptbutton:()=>{
//                        $.when(dlgug_submitUsergroup()).done((jd)=>{
//                            var d=JSON.parse(jd);
//                            this.setData(d);
//                            dlgeditgroup.dialog("close");
//                        });
//                    }
//                });
            },
            setData(data){
                if (data!=null)
                {
                    this.v1=data.id;
                    this.utext="";
                    if (data.text!=null)
                    {
                        this.utext=data.text;
                        this.$emit("input",this.v1);
                    }
                    else
                    {
                        if ((data.id!="")&&(data.id!=null))
                        {
                            axios.post("headless.php",qs.stringify({
                                action:"core_getUsergroupText",
                                id:data.id
                            })).then(d=>{ 
                                this.utext=d.data;
                                this.$emit("input",this.v1);
                            });
                        }
                    }
                }
            },
            submitUsergroup(){
                var res=eval("dlgug_getSubmitAction();");
                this.updating=true;
                axios.post("headless.php?action=core_updateUsergroup",qs.stringify(res)).then(d=>{
                    console.log(d.data);
                    this.setData(d.data);
                    this.dialogOpen=false;
                    this.$emit("updated",d.data);
                });
            },
            setInnerHTML(elm, html) {
                elm.innerHTML = html;
                Array.from(elm.querySelectorAll("script")).forEach( oldScript => {
                    const newScript = document.createElement("script");
                    Array.from(oldScript.attributes)
                      .forEach( attr => newScript.setAttribute(attr.name, attr.value) );
                    newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                    oldScript.parentNode.replaceChild(newScript, oldScript);
                });
            }
        },
        watch:{
            value:{
                immediate:true,
                handler(newVal,oldVal){
                    this.setData({ id:newVal });
                }
            }
        }
    }

</script>